import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Send = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M22 12L3 20L6.5625 12L3 4L22 12Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M6.5 12L22 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="outline">{t1}{t2}{" "}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { Send };